<template>
  <div class="step step--career-select">
    <button-back @back="back"></button-back>
    <div class="text-center">
      <div align-h="center">
        <div xl="4" lg="6" md="8" sm="12">
          <div class="mb-4">
            <icon-briefcase class="select__icon"/>
            <h2>Fantastic! Let’s focus on that one.</h2>
          </div>
          <!-- <select v-model="user.occupation">
            <option v-for="occupation in lists.occupations" v-bind:value=occupation v-bind:key=occupation>{{ occupation }}</option>
          </select> -->
          <div class="step__multiselect step__multiselect--single">
            <multiselect ref="careerSelect" v-model="selection.career" :options="lists.occupations" :preserve-search="true" :multiple="false" placeholder="" @input="onChange" @open="onOpen">
              <template slot="singleLabel" slot-scope="{ option }">
                <span class="custom__tag">
                  <span class="custom__tag-label">Select a state</span>
                  <span>{{ option }}</span>
                </span>
              </template>
              <template slot="option" slot-scope="{ option }">
                <span>{{option}}</span>
              </template>
              <span slot="noResult" slot-scope="{ search }">We can’t find a match for {{ search }}. Try entering a broader term or subject.</span>
            </multiselect>
            <div class="multiselect__label">
              Enter a career
            </div>
          </div>
        </div>
      </div>
      <div align-h="center" class="mt-3">
        <div xl="3" lg="4" md="6" cols="8">
          <small>Don’t see a match? Choose a similar career to the one you’re considering.</small>
        </div>
      </div>
      <div class="text-left no-gutters" align-h="center">
        <disclaimer />
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import ButtonBack from '../buttons/Back.vue'
import IconBriefcase from '../animatedicons/IconBriefcase.vue'
import Disclaimer from '../Disclaimer.vue'

export default {
  name: 'CareerSelectStep',
  props: {
    user: Object,
    lists: Object,
    selection: Object,
  },
  components: {
    IconBriefcase,
    Multiselect,
    ButtonBack,
    Disclaimer,
  },
  methods: {
    back: function () {
      this.$emit('back');
    },
    onChange: function(){
      setTimeout(() => {
        const container = this.$refs.careerSelect.$el.parentElement;
        const value = this.$refs.careerSelect.getValue();

        if ( typeof value === 'string' ) {
          container.classList.add('limit');
          this.user.occupation = value;
        } else {
          container.classList.remove('limit');
        }
      }, 0);
    },
    onOpen: function() {
      if ( window.innerWidth < 768 ) {
        window.scrollTo({
          top: window.scrollY + this.$refs.careerSelect.$el.getBoundingClientRect().top - 200,
          behavior: 'smooth'
        })
      }
    }
  },
  mounted: function () {
    this.onChange();
  },
  watch: {
    'user.occupation': function () {
      if( this.$refs.careerSelect.getValue() ) {
        if (this.user.occupation === null){
          return;
        }
      }
      this.$emit('completed');
    },
  },
}
</script>

<style scoped>
</style>
